var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShakeCat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.905605,
    y: 0.905605,
    width: 43.469,
    height: 43.469,
    rx: 21.7345,
    stroke: "#FCC436",
    strokeWidth: 1.81121
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9 17.9521H32.455",
    stroke: "#FCC436",
    strokeWidth: 2.65071,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6521 19.3719C16.5973 18.6048 17.205 17.9521 17.9742 17.9521H28.3809C29.15 17.9521 29.7577 18.6048 29.7029 19.3719L28.5669 35.2762C28.5173 35.9698 27.9402 36.5071 27.2449 36.5071H19.1101C18.4148 36.5071 17.8377 35.9698 17.7881 35.2762L16.6521 19.3719Z",
    stroke: "#FCC436",
    strokeWidth: 2.65071
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1775 13.9761V11.3254C23.1775 10.5934 23.7709 10 24.5028 10H26.4909",
    stroke: "#FCC436",
    strokeWidth: 2.65071,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0288 15.0835C17.1353 14.4444 17.6883 13.976 18.3362 13.976H28.0188C28.6667 13.976 29.2197 14.4444 29.3262 15.0835L29.8043 17.9521H16.5507L17.0288 15.0835Z",
    fill: "#FCC436",
    stroke: "#FCC436",
    strokeWidth: 2.65071
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShakeCat);
export default __webpack_public_path__ + "static/media/shakeCat.e42f1480b4ea360af03ce1aec7999459.svg";
export { ForwardRef as ReactComponent };